import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(<path d="M3 17h18v2H3zm0-7h18v5H3zm0-4h18v2H3z" />, 'CalendarViewDay');
